// extracted by mini-css-extract-plugin
module.exports = {"inputText":"SearchTerm_inputText_3iOQh"};